<template>
    <b-container fluid class="mt-4 pl-4">
        <p><router-link to="/">Back to Home</router-link></p>
        <h4>FarmD User Manual ({{ gameVersion }}) (under construction)</h4>

        <h3 class="mt-4">Overview</h3>
        
        <h2 class="mt-4">
            Pages
        </h2>
        <p><router-link :to="{name: 'user-manual-pages', params: {pageName: 'Gameplay'}}">Gameplay</router-link></p>
        <p><router-link :to="{name: 'user-manual-pages', params: {pageName: 'Menus'}}">Menus</router-link></p>
        <p><router-link :to="{name: 'user-manual-pages', params: {pageName: 'ModdingQuickstart'}}">Modding Quickstart Guide</router-link></p>
        <p><router-link :to="{name: 'user-manual-pages', params: {pageName: 'Miscellaneous'}}">Miscellaneous</router-link></p>
    </b-container>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "UserManualHomepage",
		computed: {
			...mapState(['gameVersion']),
        }
    }
</script>
